import Vue from "vue";
import axios from "axios";
import store from "../store";
import { Toast } from "vant";
// import { encryptToken } from '@/utils/encrypt'
// import layerActual from 'vue-layer'
// import 'vue-layer/lib/vue-layer.css'
// const layer = layerActual(Vue)

axios.defaults.timeout = 600000;

const loadingWhite = []; // 禁止loading名单
let loading = 0;
let layerLoad = null; // loading实例

export default function uploadFile(formData, url = "") {
  if (loadingWhite.indexOf(url) === -1) {
    loading++;
  }
  if (!layerLoad && loading) {
    // layerLoad = layer.loading({ content: '上传中', shade: true, shadeClose: false })
  }
  return new Promise((success, error) => {
    axios
      .post(store.state.interfacePath + "upload", formData, {
        headers: {
          "user-token": store.state.loginRecord.ext,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        let res = response.data;
        if (loading) {
          loading--;
          if (loading === 0) {
            // layer.close(layerLoad)
            layerLoad = null;
          }
        }
        if (res.code !== 0) {
          Toast(res.msg);
          if (res.code === -102) {
            location.reload();
          }
          error(res.msg);
        } else {
          success(res);
        }
      })
      .catch((response) => {
        if (loading) {
          // layer.close(layerLoad)
          layerLoad = null;
        }
        console.log(response);
      });
  });
}
